module.exports = __webpack_public_path__ + "media/images/pages/bg_area_07-03fd622d18735f3f5f19c4550d329ec2.png";